module.exports = __webpack_public_path__ + "static/media/stop.a883fe66.svg";